module.exports = __webpack_public_path__ + "static/media/provide.ac660b91.png";